import { IComputeMathFunction } from './IComputeMathFunction';
import { checkFiscalCode } from './implementations/checkFiscalCode';

/**
 * Funzioni generiche disponibili per le espressioni di calcolo.
 */
export const ComputeMathOtherFunctions: IComputeMathFunction[] = [
  {
    name: 'check_codice_fiscale',
    description:
      'Confronta il CF con i dati forniti. Restituisce `true` se il CF è corretto, `false` altrimenti.',
    arguments: [
      { type: 'string' },
      { type: 'string' },
      { type: 'string' },
      { type: 'date' },
      { type: 'string' },
      { type: 'string' },
    ],
    returnType: 'boolean',
    signature:
      'check_codice_fiscale(CF: Stringa, Nome: Stringa, Cognome: Stringa, Data di nascita: Data, Cod. Catastale: Stringa, Sesso: Stringa): Booleano',
    fn: MathJs =>
      MathJs.typed('check_codice_fiscale', {
        [`string, string, string, string, string, string`]: checkFiscalCode,
      }),
  },
];
